export default __webpack_public_path__ + "static/media/excel.8c4a4ac9.jpg";